module.exports = __webpack_public_path__ + "static/riverrock-2024.9fcd2f15.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/riverrock-2024.jpeg
// module id = 349
// module chunks = 52007029612993 174448160903362